import React from 'react';
import Confetti from 'react-confetti';
import './ReponseJuste.scss';

const ReponseJuste = ({ pointsGagnes, onContinue, anecdote, disabled }) => {
    // Le texte par défaut en attendant que tu mettes à jour ton JSON plus tard
    const texteAnecdote = anecdote || "L'anecdote liée à cette question arrivera bientôt dans la prochaine mise à jour de notre base de données !";

    return (
        <div className="modal-overlay">
            
            {/* L'animation des confettis doit être insérée ici */}
            <Confetti
                width={window.innerWidth}
                height={window.innerHeight}
                recycle={false} // Les confettis s'arrêtent après une belle pluie
                numberOfPieces={300}
                gravity={0.15}
            />

            <div className="modal-content success-modal">
                
                <div className="success-header">
                    <h2>
                        Bravo !<br />
                        c'est une bonne réponse !
                    </h2>
                    <p className="points-text">+ {pointsGagnes} Points</p>
                </div>

                <div className="anecdote-box">
                    <h3>💡 Le saviez-vous ?</h3>
                    <p>{texteAnecdote}</p>
                </div>
                
                {onContinue && (
                    <button className="continue-button" onClick={onContinue} disabled={disabled}>
                        {disabled ? "En attente..." : "Continuer"}
                    </button>
                )}
                
            </div>
        </div>
    );
};

export default ReponseJuste;